import React, { useState, useEffect, Fragment } from 'react'
import PropTypes from 'prop-types'
import Close from '../../shared/icons/Close'
import { FilterForm } from '../components'
import Button from 'components/Button'
import isEqual from 'lodash/isEqual'
import get from 'lodash/get'
import { useTranslation } from 'react-i18next'

const withFilterForm = WrappedComponent => {
	const FilterFormWrap = (props) => {
		const [t] = useTranslation()
		const { baseFilter = {}, onUnmount, onFilter, ...filterProps } = get(props, ['remoteOptions', 'withFilter'], {})
		const [showFilter, setShowFilter] = useState(false)
		const [filterValues, setFilterValues] = useState(filterProps.filterValues || baseFilter)
		const [isFiltered, setIsFiltered] = useState(filterProps.filterValues && Object.keys(filterProps.filterValues).length)
		const { remoteOptions: { onFilterActive } } = props
		useEffect(() => {
			return () => {
				if(typeof onUnmount === 'function') {
					onUnmount(filterValues)
				}
			}
		})

		const setFilter = newFilterValues => {
			setIsFiltered(!isEqual(newFilterValues, baseFilter))
			setFilterValues(newFilterValues)
			setShowFilter(false)
			updateParentOnFilter(newFilterValues)
			if(typeof onFilterActive === 'function') {
				onFilterActive(true)
			}
		}
		const toggleFilterWindow = () => {
			setShowFilter(prevState => !prevState)
		}
		const clearFilter = () => {
			setIsFiltered(false)
			setFilterValues(baseFilter)
			setShowFilter(false)
			updateParentOnFilter(baseFilter)
		}
		const updateParentOnFilter = filterVals => {
			if(typeof onFilter === 'function') {
				onFilter(filterVals)
			}
		}

		const { FilterComponent, withButtons, width, height } = filterProps
		// const { filterValues, showFilter, isFiltered } = this.state
		const FilterBtn = (
			<Fragment>
				{!!isFiltered && <Close onClick={clearFilter}/>}
				<Button status='dropdown' text={t('common.buttons.filter')} onClick={toggleFilterWindow}/>
			</Fragment>
		)
		let FilterWindow = null
		if(showFilter) {
			FilterWindow = (
				<Fragment>
					<FilterForm
						withButtons={withButtons}
						filterValues={filterValues}
						setFilter={setFilter}
						clearFilter={clearFilter}
						toggleFilterWindow={toggleFilterWindow}
						FilterComponent={FilterComponent}
						width={width}
						height={height}
					/>
				</Fragment>
			)
		}
		return(
			<WrappedComponent
				{...props}
				filterValues={filterValues}
				FilterBtn={FilterBtn}
				FilterWindow={FilterWindow}
			/>
		)
	}

	FilterFormWrap.propTypes = {
		remoteOptions: PropTypes.shape({
			withFilter: PropTypes.shape({
				baseFilter: PropTypes.object, // Filter params which can't be cleared
				filterValues: PropTypes.object, // Filter params on mount
				onFilter: PropTypes.func, // Fires on submit filter form. Recieves current filter params
				onUnmount: PropTypes.func // Recieves current filter params
			})
		})
	}

	return FilterFormWrap
}

export default withFilterForm
